// Cspell:ignore Metrix
export const SignUpMatrixV1LocalStorageKey = "subscription_dataMetrix";

export const SubscriptionComboLocalStorageKey = "subscription_subscribeCombo";

export const SanitizedUrlKeys = [
  "destination",
  "eventCategory",
  "isCombo",
  "isHongKong25",
  "newsletterIds",
  "newsletterName",
  "nonce",
  "packageName",
  "payload",
  "subscription",
  "triggerPoint",
  "variant",
];

export const SignUpCompleteUrlKey = "signUpComplete";
